import React, { Component } from 'react';
import { WarningWrapper } from './style';
import { Button } from 'antd';

import { WALLET_UPGRADE_ICON } from '../../config/media';

class UpgradeWarning extends Component {
	render() {
		const { onCancel, onOk, verificatioin_level } = this.props;
		return (
			<WarningWrapper>
				<div className="upgrade-img">
					<img src={WALLET_UPGRADE_ICON} alt="upgrade" />
				</div>
				<h3>Upgrade required</h3>
				<p>
					This feature requires an upgrade from Vault:{' '}
					{verificatioin_level < 3
						? 'Lite to Business'
						: 'Business to Enterprise'}
					.
				</p>
				<p>Proceed to see Vault options.</p>
				<div className="btn-area">
					<Button onClick={onCancel}>Back</Button>
					<Button type="primary" onClick={onOk}>
						Proceed
					</Button>
				</div>
			</WarningWrapper>
		);
	}
}

export default UpgradeWarning;
